var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { attrs: { loading: _vm.loading }, on: { close: _vm.close } },
    [
      _c("template", { slot: "modal-header" }, [
        _c("h3", { staticClass: "mt-0 mb-3 clearfix" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Paramétrage du filtre")) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "flex-level flex-top",
          attrs: { slot: "modal-body" },
          on: {
            keypress: function($event) {
              return _vm.favorite.errors.clearAll()
            }
          },
          slot: "modal-body"
        },
        [
          _c("div", { staticClass: "flex pr-3 border-right" }, [
            _c("h4", { staticClass: "mt-0" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Informations du filtre")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.favorite.name,
                    expression: "favorite.name"
                  }
                ],
                staticClass: "wp-10",
                class: { "ui-state-error": _vm.favorite.errors.has("name") },
                attrs: { type: "text", required: "", readonly: !_vm.editable },
                domProps: { value: _vm.favorite.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.favorite, "name", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.favorite.errors.has("name")
                ? _c("span", { staticClass: "danger" }, [
                    _vm._v(_vm._s(_vm.favorite.errors.get("name")))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.favoriteData != null
              ? _c("small", { staticClass: "gray-60" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__("Créé par %(name)s, le %(date)s", {
                          name: _vm.favoriteData.owner,
                          date: _vm.favoriteData.created_at
                        })
                      ) +
                      "\n            "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("h5", { staticClass: "mt-5 mb-3" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Liste des filtres contenus")) + " :")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "graylist fs-3 flex-level flex-column flex-top" },
              _vm._l(_vm.filterTranslations, function(translation, index) {
                return _c("span", {
                  key: index,
                  staticClass: "graylist-item pr-8 mb-3 regular",
                  domProps: { innerHTML: _vm._s(translation) }
                })
              }),
              0
            ),
            _vm._v(" "),
            _vm.favorite.errors.has("filters")
              ? _c("span", { staticClass: "danger" }, [
                  _vm._v(_vm._s(_vm.favorite.errors.get("filters")))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex pl-3 bl-1" }, [
            _c("h4", { staticClass: "mt-0" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Paramètres du filtre sauvegardé")))
            ]),
            _vm._v(" "),
            _c("h5", { staticClass: "semibold mb-2" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Partage")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-level mb-5" }, [
              _c("label", [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Je souhaite partager ce filtre avec mes collaborateurs"
                      )
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "form-toggle form-toggle-off flex-level",
                    class: [
                      _vm.favorite.shared ? "form-toggle-on" : "form-toggle-off"
                    ],
                    attrs: { "data-form-toggle": "form-toggle" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.favorite.shared = !_vm.favorite.shared
                      }
                    }
                  },
                  [
                    _c("input", {
                      attrs: { type: "checkbox", id: "shared-toggle" },
                      domProps: { value: true }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-toggle-labels" }, [
                      _c(
                        "label",
                        {
                          attrs: {
                            "data-form-toggle": "on",
                            for: "shared-toggle"
                          }
                        },
                        [_vm._v("Partagé")]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          attrs: {
                            "data-form-toggle": "off",
                            for: "shared-toggle"
                          }
                        },
                        [_vm._v("Désactivé")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-toggle-wrapper" }, [
                      _c("span", { staticClass: "form-toggle-handle" })
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.favoriteUrl
              ? _c("div", [
                  _c("h5", { staticClass: "semibold mb-2" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Lien de partage")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Partagez ce filtre en communiquant l’adresse ci dessous"
                          )
                        ) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group clearfix" }, [
                    _c("div", { staticClass: "form-input wp-10" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "b-1 primary-50 aleft cpointer p-2 semibold br"
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.favoriteUrl) +
                              "\n                        "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasLayout
              ? _c("div", [
                  _c("h5", { staticClass: "semibold mb-2" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Affichage du tableau")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-level mb-5" }, [
                    _c("label", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Enregistrer l’ordre et l'affichage des colonnes. Ces préférences seront appliquées lors de la sélection de ce favori."
                            )
                          ) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "form-toggle form-toggle-off flex-level",
                          class: [
                            _vm.favorite.layout
                              ? "form-toggle-on"
                              : "form-toggle-off"
                          ],
                          attrs: { "data-form-toggle": "form-toggle" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.favorite.layout = !_vm.favorite.layout
                            }
                          }
                        },
                        [
                          _c("input", {
                            attrs: { type: "checkbox", id: "layout-toggle" },
                            domProps: { value: true }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-toggle-labels" }, [
                            _c(
                              "label",
                              {
                                attrs: {
                                  "data-form-toggle": "on",
                                  for: "shared-toggle"
                                }
                              },
                              [_vm._v("Activé")]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: {
                                  "data-form-toggle": "off",
                                  for: "shared-toggle"
                                }
                              },
                              [_vm._v("Désactivé")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-toggle-wrapper" }, [
                            _c("span", { staticClass: "form-toggle-handle" })
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.editable
        ? _c(
            "div",
            {
              staticClass: "mt-5 flex flex-level flex-row flex-top",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer"
            },
            [
              _c("div", { staticClass: "flex flex-column" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-level flex-right" },
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.save"),
                      disabled: _vm.isDisable
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.save($event)
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }